import {Component, inject} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {RouterLink} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {HOME_PATH} from '../../0-application/shared'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    LogoComponent,
    RouterLink,
    ToggleButtonComponent,
    MatIconButton
  ],
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  /* v8 ignore next */
  protected readonly service = inject(ConfigService)
  protected readonly HOME_PATH = HOME_PATH
}
